var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "tips-container" }, [
        _c("span", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v(_vm._s(_vm.$t("userManage.Note")) + "："),
        ]),
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "userManage.AfterResettingOriginalPasswordWillBecomeInvalidImmediately"
              )
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "detail-container" }, [
        _c(
          "div",
          {
            staticStyle: {
              "border-right": "1px solid #ddd",
              padding: "20px",
              flex: "1",
            },
          },
          [
            _c("div", [
              _vm._v(_vm._s(_vm.$t("collectionCenter.compellation"))),
            ]),
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(_vm._s(_vm.accountDetail.realName)),
            ]),
          ]
        ),
        _c("div", { staticStyle: { padding: "20px", flex: "1" } }, [
          _c("div", [_vm._v(_vm._s(_vm.$t("userManage.LoginAccount")))]),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.accountDetail.username)),
          ]),
        ]),
      ]),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "confirmRestRef",
              attrs: { model: _vm.restPassword, size: "small" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "checked",
                    rules: {
                      required: true,
                      message: _vm.$t("userManage.PleaseCheckTheConfirmation"),
                      trigger: "change",
                    },
                  },
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.restPassword.checked,
                        callback: function ($$v) {
                          _vm.$set(_vm.restPassword, "checked", $$v)
                        },
                        expression: "restPassword.checked",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "1" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("userManage.IConfirmResetThePassword")
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("userManage.ResetTemporaryWorkerAccountPassword"),
            visible: _vm.showRestPasswordTips,
            width: "800px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showRestPasswordTips = $event
            },
          },
        },
        [
          _c("div", [
            _c("div", { staticClass: "success-container" }, [
              _c("div", { staticClass: "success-icon" }, [
                _c("i", {
                  staticClass: "el-icon-check",
                  staticStyle: { color: "#0db35b", "font-size": "50px" },
                }),
              ]),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "center",
                  "font-weight": "bold",
                  "font-size": "18px",
                },
              },
              [_vm._v(_vm._s(_vm.$t("userManage.PasswordResetSuccessful")))]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "center",
                  "margin-bottom": "20px",
                },
              },
              [_vm._v(_vm._s(_vm.$t("userManage.TheNewTemporaryPassword")))]
            ),
            _c("div", { staticClass: "new-password-con" }, [
              _c("div", [
                _vm._v(_vm._s(_vm.$t("userManage.NewTemporaryPassword"))),
              ]),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "20px",
                    "font-weight": "bold",
                    margin: "10px 0",
                  },
                },
                [_vm._v(_vm._s(_vm.newPassword))]
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.copyPassword(_vm.newPassword)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("userManage.CopyPassword")))]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "password-tips" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("userManage.TheNewTemporaryPasswordCan")) +
                  " "
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmComplete },
                },
                [_vm._v(_vm._s(_vm.$t("Resource.complete")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }